import './AppIcon.css';
import { ReactComponent as Icon} from '../../assets/icon.svg';

export const AppIcon = () => {
	return (
		<Icon />
	)
}